/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { StyledIcon, StyledNavigationBarUnit, StyledNavigationBarUnitInner, StyledNavigationBarUnitLabel } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickDataProps } from '../../../utils/pick-data-props.js';
import { pickA11yProps } from '../../../utils/pick-a11y-props.js';
import {} from '../../icon/index.js';
const hasHref = (props) => {
    return 'href' in props && typeof props.href === 'string';
};
export const NavigationBarUnit = forwardRef((props, ref) => {
    const { size, active, leadingIcon, trailingIcon, children } = props;
    const iconSize = size === 'md' ? 's' : 'xs';
    const inner = (React.createElement(StyledNavigationBarUnitInner, { size: size, active: active },
        leadingIcon && React.createElement(StyledIcon, { name: leadingIcon, size: iconSize }),
        React.createElement(StyledNavigationBarUnitLabel, { size: size, active: active, "data-text": children }, children),
        trailingIcon && React.createElement(StyledIcon, { name: trailingIcon, size: iconSize })));
    if (hasHref(props)) {
        return (React.createElement(StyledNavigationBarUnit, { as: "a", ref: ref, ...pickA11yProps(props), ...pickDataProps(props), ...props }, inner));
    }
    const { ...buttonProps } = props;
    return (React.createElement(StyledNavigationBarUnit, { as: "button", ...pickA11yProps(props), ...pickDataProps(props), ref: ref, ...buttonProps }, inner));
});
NavigationBarUnit.displayName = 'NavigationBarUnit';
//# sourceMappingURL=index.js.map